import React, { ReactNode } from "react";
import { SecondaryButton } from "../Common/SecondaryButton";

interface CreatePurchaseFooterProps {
    secondaryText: string;
    onCancel: () => void;
    children: ReactNode;
}

export const CreatePurchaseFooter = ({ secondaryText, onCancel, children }: CreatePurchaseFooterProps) => {
    return (
        <footer className="absolute bottom-0 left-0 flex w-full justify-between border-t border-t-gray-light bg-white px-6 py-4">
            <SecondaryButton onClick={onCancel}>{secondaryText}</SecondaryButton>
            <div className="flex flex-row-reverse space-x-4 space-x-reverse">{children}</div>
        </footer>
    );
};
